import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

const TOKEN_KEY = 'rs_admin_token';

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (token) => localStorage.setItem(TOKEN_KEY, token),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

api.interceptors.request.use((config) => {
  const t = auth.getToken();
  if (t && config.url?.startsWith('/admin')) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && err.config?.url?.startsWith('/admin')) {
      auth.clear();
    }
    return Promise.reject(err);
  }
);

export const submitContact = (payload) => api.post('/contact', payload).then((r) => r.data);

export const adminLogin = (username, password) =>
  api.post('/admin/login', { username, password }).then((r) => r.data);

export const adminMe = () => api.get('/admin/me').then((r) => r.data);

export const listRichieste = (statusFilter = 'all') =>
  api
    .get('/admin/richieste', { params: statusFilter ? { status_filter: statusFilter } : {} })
    .then((r) => r.data);

export const updateRichiestaStatus = (id, newStatus) =>
  api.patch(`/admin/richieste/${id}`, { status: newStatus }).then((r) => r.data);

export const deleteRichiesta = (id) =>
  api.delete(`/admin/richieste/${id}`).then((r) => r.data);

export const listUsers = () => api.get('/admin/users').then((r) => r.data);

export const createUser = (payload) =>
  api.post('/admin/users', payload).then((r) => r.data);

export const updateUser = (id, payload) =>
  api.patch(`/admin/users/${id}`, payload).then((r) => r.data);

export const deleteUser = (id) =>
  api.delete(`/admin/users/${id}`).then((r) => r.data);

export const changeOwnPassword = (current_password, new_password) =>
  api.post('/admin/me/password', { current_password, new_password }).then((r) => r.data);
